import { GenericObject } from "utility/misc";

export default function redirectToSplunkCloudWebhookConnectPage(
  orgStore: GenericObject,
  navigate: Function
): void {
  navigate("/environment/destinations/splunk_cloud_webhook/connect");
}
